import React from 'react'
import { Typography } from '@mui/material'
// Components
import NotificationModal from '../notification'

const TerminalPvModal = ({ open, onAccept }) => {
  return (
    <NotificationModal
      open={open}
      variant='warning'
      onAccept={onAccept}
    >
      <Typography variant="body1" component="p">
        Esta venta contiene pago/s con Terminal integrada. Debes seleccionar un Punto de Venta con terminal integrada configurada para realizar cambios / devoluciones.
      </Typography>
      </NotificationModal>
  )
}

export default TerminalPvModal